import { brandPrimary } from '../../styles/colors';
import { CssSelectors, CtaButtons } from '../../styles/styles';
import { CSSProperties, StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	body: {
		color: '#4A4A4A',
		fontSize: 14,
		margin: '20px 0',
		maxHeight: 400,
		overflowY: 'auto',
	},
	cancelButton: {
		...(CtaButtons.ctaButtonReverse as CSSProperties),
	},
	container: {},
	footer: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	header: {
		textAlign: 'right',
	},
	radio: {
		...CssSelectors.allChildren(
			{
				marginTop: 10,
			},
			':not(:first-child)'
		),
	},
	title: {
		color: brandPrimary,
		fontSize: 18,
		textAlign: 'center',
	},
});
